export const BRAND = {
  name: "Enrich Hair & Beauty",
  tagline: "Luxury Hair & Beauty Salon in Pendle Hill",
  address: "59A Wyena Road, Pendle Hill NSW 2145",
  phone: "0414 332 884",
  phoneIntl: "61414332884",
  email: "hello@enrichhairbeauty.com.au",
  logo: "https://customer-assets.emergentagent.com/job_enrich-salon-2/artifacts/ksdaqvrv_867e7fc4-38c6-4a0d-9c5e-f652fe4bf8cd.jpeg",
  instagram: "https://instagram.com/",
  facebook: "https://facebook.com/",
  tiktok: "https://tiktok.com/",
};

export const SERVICE_CATEGORIES = [
  {
    id: "hair",
    title: "Hair Services",
    image: "https://images.unsplash.com/photo-1554519934-e32b1629d9ee?w=1200&q=80",
    items: [
      { name: "Kids Hair Cut", price: "$20" },
      { name: "Hair Trim", price: "$20" },
      { name: "Hair Style Cut", price: "$40" },
      { name: "Hair Wash", price: "$15" },
      { name: "Blow Dry", price: "$30" },
      { name: "Hair Styling", price: "$50" },
      { name: "Root Touch Up", price: "$40" },
      { name: "Full Head Colour", price: "$55" },
      { name: "Half Head Foils", price: "From $89" },
      { name: "Full Head Foils", price: "From $120" },
      { name: "Toner", price: "$40" },
      { name: "Hair Heena", price: "$40" },
      { name: "Oil Massage", price: "$30" },
      { name: "Hair Spa", price: "From $40" },
      { name: "Keratin Treatment", price: "From $169" },
      { name: "Nanoplasty Treatment", price: "From $269" },
    ],
  },
  {
    id: "threading",
    title: "Threading & Waxing",
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&q=80",
    items: [
      { name: "Eyebrow", price: "$10" },
      { name: "Upper Lip", price: "$5" },
      { name: "Nose", price: "$5" },
      { name: "Chin", price: "$5" },
      { name: "Forehead", price: "$8" },
      { name: "Cheeks", price: "$8" },
      { name: "Neck", price: "$8" },
      { name: "Sideburns", price: "$8" },
      { name: "Full Face Threading", price: "$40" },
      { name: "Full Face Waxing", price: "$40" },
      { name: "Half Arms", price: "$20" },
      { name: "Full Arms", price: "$32" },
      { name: "Underarms", price: "$15" },
      { name: "Half Back", price: "$20" },
      { name: "Full Back", price: "$35" },
      { name: "Half Legs", price: "$27" },
      { name: "3/4 Legs", price: "$32" },
      { name: "Full Legs", price: "$39" },
      { name: "Stomach", price: "$25" },
      { name: "Brazilian", price: "$40" },
      { name: "Bikini Line", price: "$15" },
      { name: "Full Body", price: "$150" },
    ],
  },
  {
    id: "facial",
    title: "Facial Treatments",
    image: "https://images.pexels.com/photos/37229299/pexels-photo-37229299.jpeg?w=1200&q=80",
    items: [
      { name: "Express Cleanse", price: "$25" },
      { name: "Bleach Facial", price: "$45" },
      { name: "Deep Pore Facial", price: "$50" },
      { name: "D-Tan Facial", price: "$50" },
      { name: "Gold Hydrating Facial", price: "$60" },
      { name: "O3+ Facial", price: "$70" },
    ],
  },
  {
    id: "makeup",
    title: "Makeup & Hairstyle",
    image: "https://images.pexels.com/photos/32388557/pexels-photo-32388557.jpeg?w=1200&q=80",
    items: [
      { name: "Party Makeup & Hairstyle", price: "$120" },
      { name: "Saree / Dupatta Draping", price: "$25" },
    ],
  },
];

export const ALL_SERVICE_NAMES = SERVICE_CATEGORIES.flatMap(c => c.items.map(i => i.name));

export const GALLERY_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "hair", label: "Hair Transformations" },
  { id: "highlights", label: "Highlights" },
  { id: "balayage", label: "Balayage" },
  { id: "keratin", label: "Keratin" },
  { id: "nanoplasty", label: "Nanoplasty" },
  { id: "facials", label: "Facials" },
  { id: "makeup", label: "Makeup" },
  { id: "eyebrows", label: "Eyebrows" },
  { id: "waxing", label: "Waxing" },
];

export const GALLERY_ITEMS = [
  { cat: "hair", title: "Layered Cut & Blowout", src: "https://images.unsplash.com/photo-1560869713-bf165a9cfac1?w=900&q=80" },
  { cat: "highlights", title: "Honey Highlights", src: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=900&q=80" },
  { cat: "balayage", title: "Caramel Balayage", src: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=900&q=80" },
  { cat: "keratin", title: "Keratin Smoothing", src: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=900&q=80" },
  { cat: "nanoplasty", title: "Nanoplasty Shine", src: "https://images.unsplash.com/photo-1559599101-f09722fb4948?w=900&q=80" },
  { cat: "facials", title: "Gold Hydrating Facial", src: "https://images.pexels.com/photos/3997989/pexels-photo-3997989.jpeg?w=900&q=80" },
  { cat: "makeup", title: "Bridal Glam", src: "https://images.pexels.com/photos/32388557/pexels-photo-32388557.jpeg?w=900&q=80" },
  { cat: "eyebrows", title: "Brow Shaping", src: "https://images.unsplash.com/photo-1583241800698-9c2e1d2113a0?w=900&q=80" },
  { cat: "waxing", title: "Smooth & Silky", src: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=900&q=80" },
  { cat: "hair", title: "Sleek Straight", src: "https://images.unsplash.com/photo-1605980776566-0486c3ac7617?w=900&q=80" },
  { cat: "highlights", title: "Babylights", src: "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=900&q=80" },
  { cat: "balayage", title: "Ash Blonde Balayage", src: "https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?w=900&q=80" },
];

export const BEFORE_AFTER = [
  {
    title: "Keratin Smoothing",
    before: "https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&q=80",
    after: "https://images.unsplash.com/photo-1605980776566-0486c3ac7617?w=900&q=80",
  },
  {
    title: "Balayage Transformation",
    before: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=900&q=80",
    after: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=900&q=80",
  },
  {
    title: "Highlights & Toner",
    before: "https://images.unsplash.com/photo-1554519934-e32b1629d9ee?w=900&q=80",
    after: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=900&q=80",
  },
];

export const WHY_CHOOSE_US = [
  { title: "Premium Products", desc: "Salon-grade brands & nourishing formulas for healthy, radiant results.", icon: "Sparkles" },
  { title: "Expert Stylists", desc: "Trained specialists in colour, smoothing, and bridal styling.", icon: "Scissors" },
  { title: "Relaxing Atmosphere", desc: "An elegant, calming space designed for your comfort.", icon: "Flower2" },
  { title: "Tailored to You", desc: "Personalised consultations so every look feels uniquely yours.", icon: "Heart" },
];

export const INSTAGRAM_FEED = [
  "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600&q=80",
  "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80",
  "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=600&q=80",
  "https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?w=600&q=80",
  "https://images.unsplash.com/photo-1559599101-f09722fb4948?w=600&q=80",
  "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&q=80",
];

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
];
